import React from 'react';

export default function replaceNewLinesForHtml(value) {
  const newLineRegExp = /(\r\n|\n|\r)/gm;

  var values = value.split(newLineRegExp);
  var result = [];

  for (var i = 0; i < values.length; i++) {
    var txt = values[i];

    if (!txt || newLineRegExp.test(txt)) {
      continue;
    }
    if (i < values.length - 1) {
      result.push(
        <span key={i}>
          {txt}
          <br />
        </span>
      );
    } else {
      result.push(<span key={i}>{txt}</span>);
    }
  }

  return <div>{result}</div>;
}
